import React from "react";

import InvoiceDetails from "components/Invoice";

const Invoice = () => {
  return <InvoiceDetails />;
};

export default Invoice;
